import { Field } from "formik";
import { Select } from "antd";

import "./style.css";

const InputField = (props) => {
  return (
    <div style={{ ...props.style }} className="form-section">
      <div>{props.title}</div>
      <Field name={props.name}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            <input
              {...props}
              style={{ ...props.inputstyle }}
              className={
                "form-section-input " +
                (props.inputClassname ? props.inputClassname : "")
              }
              type={props.type || "text"}
              placeholder={props.placeholder || props.title}
              {...field}
            />
            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
};

const InputWithPrefix = (props) => {
  return (
    <div style={{ ...props.style }} className="form-section">
      <div>{props.title}</div>
      <Field name={props.name}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            <div className="input-with-prefix">
              <div className="prefix-input">{props.prefix && props.prefix}</div>
              <input
                style={{ ...props.inputstyle }}
                className="form-section-input"
                type={props.type || "text"}
                placeholder={props.title}
                {...field}
              />
            </div>
            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
};

const SelectField = (props) => {
  return (
    <div style={{ ...props.style }} className="form-section">
      <div>{props.title}</div>
      <Field name={props.name}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors, setFieldValue, values }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            <Select
              placeholder="انتخاب کنید"
              style={{
                border: "none",
                height: 40,
                paddingRight: 0,
                ...props.selectStyle,
              }}
              className="form-section-input"
              onChange={(val) => setFieldValue(props.name, val)}
              value={field.value}
            >
              {props.options.map((item) => (
                <Select.Option value={item.id}>{item.name}</Select.Option>
              ))}
            </Select>

            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
};

const TextAreaField = (props) => {
  return (
    <div style={{ ...props.style }} className="form-section">
      <div>{props.title}</div>
      <Field name={props.name}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <div>
            <textarea
              {...props}
              style={{ ...props.inputstyle }}
              className={
                "form-section-input " +
                (props.inputClassname ? props.inputClassname : "")
              }
              type="text"
              placeholder={props.placeholder || props.title}
              {...field}
            />
            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
};

export { InputField, InputWithPrefix, SelectField, TextAreaField };
